<template>
	<div class="animated fadeIn">
		<form @submit.prevent="validateBeforeSubmit">
	
			<flCarregando v-if="carregando" />
	
			<div v-if="!carregando">
				<div class="row">
					<div class="col-lg-12">
						<h3 class="animated slideInDown">
							<span><fa-icon icon="history" /> Histórico
							<button type="button" @click="exibeCadastro = true" :disabled="form.id != 0 && !_getPrivilegio(12)" v-if="!exibeCadastro" class="btn float-right btn-sm  btn-outline-primary">
								<fa-icon icon="plus"/> Adicionar
							</button>
							<button type="button" @click="exibeCadastro = false" v-if="exibeCadastro" class="btn float-right btn-sm  btn-outline-primary">
								<fa-icon icon="times"/> Fechar
							</button>
							</span>
						</h3>
						<small class="text-info float-right" v-if="!_getPrivilegio(12)">VOCÊ NÃO TEM PERMISSÃO.</small>
					</div>
				</div>
	
	
				<form v-if="exibeCadastro" style="margin-top:1em" @submit.prevent="validateBeforeSubmit">
	
					<div class="row">
						<div class="col-lg-12">
							<div class=" form-group">
								<label for="exampleInputEmail1">*Descrição:</label>
								<textarea type="text"
										name="descrição"
										v-validate="'required'"
										:class="{'is-invalid' : errors.has('descrição')}"
										v-model.trim="form.descricao"
										rows="2"
										class="form-control form-control-sm"></textarea>
								<span  class="invalid-feedback" v-show="errors.has('descrição')">{{ errors.first('descrição') }}</span>
							</div>
						</div>
					</div>
	
					<div class="form-group row">
						<div class="col-sm-12 text-right">
							<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
							<button class="btn btn-success btn-sm">
								<fa-icon icon="check" transform="left-3" /> SALVAR
							</button>
						</div>
					</div>
	
				</form>
	
				<div class="row" style="margin-top:2em">
					<div class="col-md-12 text-center form-group" v-if="form.historicos.length == 0">
						Nenhum histórico encontrado.
					</div>
					<div class="col-md-12 form-group" v-for="(item, index) in form.historicos" :key="index">
						<div>
							<strong>{{item.nome}}</strong>
							<small class="float-right">{{item._data}}</small>
						</div>
						<blockquote contenteditable="true">
    						<p :id="item.id">{{item.descricao}}</p>
						</blockquote>
						<button class="btn btn-danger" @click.prevent="deletar(item)">
							Deletar
						</button>
						<button class="btn btn-secondary" @click.prevent="edit(item)">
							Editar
						</button>
						<hr />
					</div>
				</div>
			</div>
		</form>
	</div>
	</template>
	
	<script>
	import _ from 'lodash'
	import moment from 'moment'
	import axios from '../../../routers/axios'
	import flCarregando from '../../../components/carregando/main.vue'
	export default {
	
		components: {
			flCarregando
		},
	
	
		computed: {
			servidores_ () {
				return _.orderBy(this.servidores, 'descricao', 'desc')
			},
		},
	
		data(){
			return {
	
				exibeCadastro: false,
				carregando: false,
				form: {
					id: 0,
					tipo: "",
					imei: "",
					prefixo: "",
					descricao: "",
					data: "",
					historicos: [],
				},
			}
		},
	
		mounted () {
			axios.get(this._getUrl('api/servidorenvio')).then(response => {
				if(response.status == 200){
					this.servidores = response.data
				}
			})
		},
	
		methods: {
	
			editar(item){
				this.form.id = item.id
				this.form.tipo = item.tipo
				this.form.imei = item.imei
				this.form.prefixo = item.prefixo
				this.carregaHistoricos(item.id);
			},

			carregaHistoricos(id){
				this.carregando = true
				axios.get(this._getUrl(`api/equipamentohistorico/${id}`)).then(response => {
					this.carregando = false
					this.form.historicos = response.data.map((it) => {
						it._data = new moment(it.data).format("DD/MM/YYYY HH:mm")
						return it
					})
				})
			},
	
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.salva();
					}
				});
			},
	
			salva(){
	
				this.$notify.loadIn('Salvando')
	
				var data = {
					idEquipamento: this.form.id,
					nome: this.$store.state.sessao.user.nome,
					descricao: this.form.descricao
				}
	
				axios.post(this._getUrl('api/equipamentohistorico'), data).then(response => {
	
					this.form.descricao = ''
					this.errors.clear();
					response.data._data = new moment(response.data.data).format("DD/MM/YYYY HH:mm")
					this.form.historicos.unshift(response.data)
					this.$notify.show('success', 'Histórico salvo.')
				})
	
			},
	
			deletar(item){
				var result = confirm("Deseja deletar?")
				
				if(result)
				{
					axios.delete(this._getUrl(`api/equipamentohistorico/${item.id}`)).then(response => {
						this.$notify.show('success', 'Historico deletado.')
					})
				}
			},

			edit(item){
				var result = confirm("Deseja editar?")

				if(result)
				{
					var data = {
						id: item.id,
						nome: this.$store.state.sessao.user.nome,
						descricao: document.getElementById(`${item.id}`).innerHTML,
						idEquipamento: item.idEquipamento
					}

					axios.put(this._getUrl('api/equipamentohistorico'), data).then(response => {	
						this.$notify.show('success', 'Historico atualizado.')
					})
				}				
			},
		}
	}
	</script>
	


// WEBPACK FOOTER //
// src/views/equipamento/detalhe/historico.vue